/// <reference path="../base/api.js" />
/// <reference path="../vendors/intact/jquery-3.4.1.js" />

(function ($) {
    api.fn = {
        getWindDims: function () {
            var dims = api.fn.viewport();
            api.vars.windW = dims.width;
            api.vars.windH = dims.height;

            api.vars.is = api.fn.is();

            //console.log("resp:", resp)

            //  console.log("is", api.vars.is)
        },

        is: function () {
            if (api.vars.windW < api.vars.scr.tablet) {
                return "phone";
            } else if (api.vars.windW < api.vars.scr.desktop) {
                return "tablet";
            }
            return "desktop";
        },

        checkTouchDevice: function () {
            api.isTouch = $("html").hasClass("touchevents");
        },

        checkFontsIconsLoad: function () {
            if (document.documentElement.className.indexOf("font-icons-loaded") > -1) {
                return;
            }
            var fontIcons = new FontFaceObserver("icons", {
                weight: 400
            });

            fontIcons.load(null, 15000).then(function () {
                document.documentElement.className += " font-icons-loaded";
            }, function () {
                document.documentElement.className += " font-icons-loaded";
            });
        },

        disableBodyScroll: function () {
            var scrollTop = $(window).scrollTop();

            api.winTopMemory = scrollTop;

            $("body").css({
                position: "fixed",
                width: "100%",
                top: -scrollTop,
            });
            $("html, body").addClass("scrollDisabled");
        },

        enableBodyScroll: function () {
            $("body").css({
                position: "static",
                top: "auto",
            });
            $(window).scrollTop(api.winTopMemory);
            $("html, body").removeClass("scrollDisabled");
        },

        onEnterTriggerBtn: function () {
            $(".triggerEnter").on("keydown", function (e) {
                var inpt = $(this);
                var code = e.keyCode ? e.keyCode : e.which;
                if (code === 13) {
                    var btnId = inpt.data("triggerbtn");
                    $("#" + btnId).trigger("click");
                    return false;
                }
            });
        },

        setAnchors: function () {
            $(".anchorLnk").on("click", function (e) {
                e.preventDefault();

                var lnk = $(this);
                var target = $(lnk.attr("href"));
                if (target.length) api.fn.moveWindowToObj(target);
            });
        },

        toFocus: function (slc) {
            $(".toFocus").on("touchstart", function () {
                $(this).focus();
            });
        },

        toFocusThis: function (obj) {
            $(obj).on("touchstart", function () {
                $(this).focus();
            });
        },

        focusfix: function (selector, className) {
            $(selector).focus(function () {
                $(this).addClass(className);
            });
            // Removes class when focus is lost
            $(selector).blur(function () {
                $(this).removeClass(className);
            });
        },

        viewport: function () {
            var e = window,
                a = "inner";
            if (!("innerWidth" in window)) {
                a = "client";
                e = document.documentElement || document.body;
            }
            return { width: e[a + "Width"], height: e[a + "Height"] };
        },

        onEscTriggerReset: function () {
            function resetTxt(btn) {
                var txtId = btn.data("textreset");
                $("#" + txtId).val("");
                btn.hide();
            }

            var txtId = $(".resetTxtBtn").data("textreset");
            if ($("#" + txtId).val() === "") {
                //$('.resetTxtBtn').hide();
            }

            $(".resetTxtBtn").on("click", function (e) {
                e.preventDefault();
                var btn = $(this);
                resetTxt(btn);
                return false;
            });

            $(".resetEsc").on("keydown", function (e) {
                var inpt = $(this);
                var btnId = inpt.data("triggerreset");
                var btn = $("#" + btnId);
                btn.show();
                var code = e.keyCode ? e.keyCode : e.which;
                if (code === 27) {
                    btn.trigger("click");
                    //resetTxt(btn);
                    return false;
                }
            });
        },

        /*-- PRELOADER REPLACING BUTTONS : START --*/
        iniPostPreloader: function (selector, ToPrepend) {
            function getBtnSize(btn) {
                return {
                    w: btn.outerWidth(),
                    h: btn.outerHeight(),
                };
            }

            var btn = $(selector);
            var btnDisplay = btn.css("display");
            var btnSizes = getBtnSize(btn);
            var btnWrap = btn.parent();
            btn.hide();
            var prel = $(
                '<div class="btnPreloader" style="display:' +
                    btnDisplay +
                    "; width:" +
                    btnSizes.w +
                    "px; height:" +
                    btnSizes.h +
                    'px;"><div class="btnPreloader__ins"><div></div><div></div><div></div></div></div>'
            );

            if (ToPrepend) {
                prel.insertBefore(btn);
            } else {
                prel.insertAfter(btn);
            }

            $(window).on("resize.preloader", function () {
                var btn = prel.prev();
                btn.show();
                btnSizes = getBtnSize(btn);
                prel.css({
                    width: btnSizes.w,
                    height: btnSizes.h,
                });
                btn.hide();
            });
        },

        removePostPreloader: function (selector) {
            var btn = $(selector);
            var btnWrap = btn.parent();
            $(window).off("resize.preloader");
            btnWrap.find(".btnPreloader").remove();
            btn.show();
        },
        /*-- PRELOADER REPLACING BUTTONS : END --*/

        getData: function (obj, datastr, defVal) {
            var str = "";
            if (typeof defVal !== "undefined") str = defVal;
            if (typeof obj.data(datastr) !== "undefined")
                str = obj.data(datastr);
            return str;
        },

        shuffle: function (o) {
            for (
                var j, x, i = o.length;
                i;
                j = parseInt(Math.random() * i),
                    x = o[--i],
                    o[i] = o[j],
                    o[j] = x
            );
            return o;
        },

        /*-- Print Specified Element by Id --*/
        printPage: function (id, pageTitle) {
            pageTitle = pageTitle ? pageTitle : "";
            var html =
                "<!doctype html><html><head><title>" +
                pageTitle +
                "</title></head><body>";
            html += document.getElementById(id).innerHTML;
            html += "</body></html>";
            var printWin = window.open(
                "",
                "",
                "left=0,top=0,width=1,height=1,toolbar=0,scrollbars=0,status=0"
            );
            printWin.document.write(html);
            printWin.document.close();
            printWin.focus();
            printWin.print();
            printWin.close();
        },

        getHeaderHeight: function () {
            return $(".header").outerHeight();
        },

        moveWindowToObj: function (obj, offset, callback) {
            var windowscrollTop = $(window).scrollTop();
            offset = !offset ? 0 : offset;
            var objToPos = 0;
            if (obj.is(":hidden")) {
                obj.show();
                objToPos = $(obj).offset();
                obj.hide();
            } else {
                objToPos = $(obj).offset();
            }

            var headerH = api.fn.getHeaderHeight();
            headerH = headerH ? headerH : 0

            $("html,body").clearQueue();
            $("html,body").stop();
            $("html,body")
                .stop()
                .animate(
                    { scrollTop: objToPos.top + offset - headerH },
                    400,
                    function () {
                        if (callback) {
                            if (typeof callback === "function") {
                                callback();
                            }
                        }
                    }
                );
        },

        moveWindowToScrollPoint: function (scrlPoint, callback) {
            $("html,body").clearQueue();
            $("html,body").stop();
            $("html,body")
                .stop()
                .animate({ scrollTop: scrlPoint.top }, 400, function () {
                    if (callback) {
                        if (typeof callback === "function") {
                            callback();
                        }
                    }
                });
        },

        getQueryByName: function (name) {
            name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                results = regex.exec(location.search);
            return results === null
                ? ""
                : decodeURIComponent(results[1].replace(/\+/g, " "));
        },

        mediaQueryCallbacks: function (
            devicesToWatch /* ['desktop', 'tablet', 'phone'] */,
            matchCallback,
            unmatchCallback
        ) {
            var mediaMatch = false;

            var mediaIs = api.vars.is; //.split(" ");

            for (var i = 0; i < devicesToWatch.length; i++) {
                if (mediaIs.indexOf(devicesToWatch[i]) >= 0) {
                    mediaMatch = true;
                }
            }

            if (mediaMatch) {
                if (matchCallback && typeof matchCallback() === "function") {
                    matchCallback();
                }
            } else {
                if (
                    unmatchCallback &&
                    typeof unmatchCallback() === "function"
                ) {
                    unmatchCallback();
                }
            }

            return mediaMatch;
        },

        checkForYouTube: function () {
            api.vars.youtubeSelectors = $(".for_youtube");

            if (api.vars.youtubeSelectors.length) {
                api.fn.addYouTubeApi();
            }
        },

        addYouTubeApi: function () {
            if (!api.fn.youtube_addedScriptToHead) {
                api.fn.youtube_addedScriptToHead = true;

                var tag = document.createElement("script");
                tag.src = "https://www.youtube.com/iframe_api";
                var firstScriptTag = document.getElementsByTagName("script")[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            }
        },

        recaptchaLoaded: function () {
            api.vars.recaptchaReady = true;
            $(document).trigger("recaptcha-loaded");
        },

        getScrollPosition: function () {
            var doc = document.documentElement;
            var pos = {};
            pos.left =
                (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
            pos.top =
                (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
            return pos;
        },

        getDate: function (element) {
            var date;
            try {
                date = $.datepicker.parseDate(
                    api.vars.datepicker.dateFormat,
                    element.value
                );
            } catch (error) {
                date = null;
            }
            return date;
        },

        youtube_embed: function () {
            function createEmbed(parent) {
                var youtube_embed = $(".youtube_embed", parent);

                var vId = api.fn.getData(youtube_embed, "vid", false);

                if (vId) {
                    $(
                        '<iframe class="youtube-iframe" src="//www.youtube.com/embed/' +
                            vId +
                            '?rel=0&version=3&autoplay=1&controls=1&enablejsapi=1&showinfo=0&loop=1&rel=0&playsinline=1​" frameborder="0" allowfullscreen></iframe>'
                    ).appendTo(youtube_embed);
                }
            }

            $(".icon-video-play").on("click", function () {
                var lnk = $(this);
                createEmbed(lnk.parents(".b-video"));

                lnk.parent().hide();
            });
            //$('<iframe style="width:100%; height:' + vH + 'px;" class="youtube-iframe" src="//www.youtube.com/embed/' + vId + '?rel=0&version=3&autoplay=1&controls=1&&showinfo=1&loop=1​" frameborder="0" allowfullscreen></iframe>').appendTo(videoHolder);
        },

        highlight: function (selector, txt) {
            var innerHTML = selector.text();
            var index = innerHTML.indexOf(txt);
            if (index >= 0) {
                innerHTML =
                    innerHTML.substring(0, index) +
                    "<span class='highlight'>" +
                    innerHTML.substring(index, index + txt.length) +
                    "</span>" +
                    innerHTML.substring(index + txt.length);
                selector.html(innerHTML);
            }
        },

        smsLnk: function () {
            link = new SMSLink.link();
            link.replaceAll();
        },

        pad: function (n) {
            if (n < 10) return "0" + n;
            return n;
        },

        preloadBodyMarkup: function () {
            return '<div class="preloaderBody"><div class="hau-spinner"></div></div>';
        },

        preloaderMarkup: function () {
            return '<div class="preloaderWrap"><div class="preloader"></div></div>';
        },

        preloadBody: function (state, callback, instant) {
            if (state) {
                if ($(".preloaderBody").length) {
                    api.fn._toggleBodyPreloader(state, callback, instant);
                } else {
                    $(api.fn.preloadBodyMarkup()).appendTo("body");
                    api.fn._toggleBodyPreloader(state, callback, instant);
                }
            } else {
                if ($(".preloaderBody").length) {
                    api.fn._toggleBodyPreloader(state, callback, instant);
                }
            }
        },

        _toggleBodyPreloader: function (state, callBack, instant) {
            var timer = instant ? 0 : 300;

            $(".preloaderBody__txt").html("");

            if (state) {
                $(".preloaderBody").fadeIn(timer, function () {
                    $("body").addClass("loading");
                    if (typeof callBack == "function") callBack();
                });
            } else {
                $(".preloaderBody").fadeOut(timer, function () {
                    $("body").removeClass("loading");
                    if (typeof callBack == "function") callBack();
                });
            }
        },

        addTextToBodyPreloader(txt) {
            var prBody = $(".preloaderBody");
            if (prBody.length) {
                if ($(".preloaderBody__txt").length) {
                    $(".preloaderBody__txt").text(txt);
                } else {
                    $(
                        `<span class="preloaderBody__txt">${txt}</span>`
                    ).appendTo(prBody);
                }
            }
        },

        modalLnk: function () {
            $("body").on("click.modalLnk", ".modalLnk", function (e) {
                e.preventDefault();


                api.fn.modalLnkTrigger($(this));


            });
        },

        modalLnkTrigger: function (lnk) {
            const modalId = $(lnk.attr("href"));
            const resetForm = api.fn.getData(lnk, "reset-form", false);
            $(".modal.show").modal("hide");
            $(modalId).modal("show");
            
            $(document).trigger("modal-triggered", {
                lnk, 
                modalId: lnk.attr("href").substr(1)
            });


            if (resetForm) {
                api.forms.resetFields($(modalId));
            }

            if ($(modalId).find(".g-recaptcha").length) {
                setTimeout(function () {
                    api.forms.resetCaptcha();
                    api.forms.iniCaptcha($(modalId));
                }, 500);
            }
        },

        modal: function (modalId, toggle) {
            var modal = $("#" + modalId);
            if (modal && modal.length) {
                if (toggle === true) {
                    $(".modal.show").modal("hide");
                    modal.modal("show");
                } else {
                    modal.modal("hide");
                }
            }
        },

        sortByButton: function () {
            $("body").on("click.sortByButton", ".btn--sortby", function (e) {
                e.preventDefault();

                var btn = $(this);
                if (btn.hasClass("asc")) {
                    btn.removeClass("asc").addClass("desc");
                } else if (btn.hasClass("desc")) {
                    btn.removeClass("desc");
                } else {
                    btn.addClass("asc");
                }

                var attr = api.fn.getData(btn, "rel", false);

                if (attr) {
                    $(attr).removeClass("asc").removeClass("desc");
                }
            });
        },

        backToTop: function () {
            $(".footer .e-back-top").on("click", function (e) {
                e.preventDefault();
                api.fn.moveWindowToObj($(".header"));
            });
        },

        convertLnkAddToEdit: function (nodeId) {
            $('.e-add-note[data-node-id="' + nodeId + '"]')
                .removeClass("e-add-note")
                .addClass("e-add-note-filled");
        },

        convertLnkEditToAdd: function (nodeId) {
            $('.e-add-note-filled[data-node-id="' + nodeId + '"]')
                .removeClass("e-add-note-filled")
                .addClass("e-add-note");
        },

        enableBodyScroll: function () {
            $("body").css({
                position: "static",
                top: "auto",
            });
            $(window).scrollTop(api.winTopMemory);
            $("html, body").removeClass("scrollDisabled");
        },

        hasCookie: function (key) {
            if (
                !key ||
                /^(?:expires|max\-age|path|domain|secure)$/i.test(key)
            ) {
                return false;
            }
            return new RegExp(
                "(?:^|;\\s*)" +
                    encodeURIComponent(key).replace(/[\-\.\+\*]/g, "\\$&") +
                    "\\s*\\="
            ).test(document.cookie);
        },

        iniWaypointElements: function () {
            var offset = $(window).height() - 300;

            $(
                ".s-img-banner__text__ins, .s-img-banner__img, .s-logos-list, .s-extra-info"
            ).each(function () {
                var elem = $(this)[0];
                var inview = new Waypoint({
                    element: elem,
                    handler: function (direction) {
                        $(this.element).addClass("onScreen");
                    },
                    offset: offset,
                });
            });
        },

        removeInlineImgSizes: function (img) {
            if (img.length) {
                img.css({
                    width: "auto",
                    height: "auto",
                });
            }
        },

        googleMapsReady: function () {
            api.vars.googleMapReady = true;
            $(document).trigger("google-map-ready");
        },

        preloadContentLikeVue: function (parentObj, callback) {
            $(parentObj).find(".preloader-abs").addClass("loaded");
            $(parentObj).find(".preloader-rel").addClass("loaded");

            setTimeout(function () {
                $(parentObj).find(".preloader-abs").addClass("entered");
                $(parentObj).find(".preloader-rel").addClass("entered");
                if (typeof callBack == "function") callBack();
            }, 500);
        },

        preloadedItem: function (obj, callback) {
            $(obj).addClass("loaded");

            setTimeout(function () {
                $(obj).addClass("entered");
                if (typeof callBack == "function") callBack();
            }, 500);
        },

        cleanBreak: function (str) {
            return str
                .replace(/<br >/g, "<br>")
                .replace(/<br \/>/g, "<br>")
                .replace(/<br\/>/g, "<br>");
        },

        getParameterByName: function (name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return "";
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        },

        setUrlParameter: function (key, value) {
            window.history.replaceState(
                "",
                "",
                api.fn.setUrlParameter_fn(key, value)
            );
        },

        setUrlParameter_fn: function (key, value) {
            var url = window.location.href,
                baseUrl = url.split("?")[0],
                urlQueryString =
                    url.split("?").length > 1 ? "?" + url.split("?")[1] : "",
                newParam = key + "=" + value,
                params = "?" + newParam;

            // If the "search" string exists, then build params from it
            if (urlQueryString) {
                var updateRegex = new RegExp("([?&])" + key + "[^&]*");
                var removeRegex = new RegExp("([?&])" + key + "=[^&;]+[&;]?");

                if (
                    typeof value === "undefined" ||
                    value === null ||
                    value === ""
                ) {
                    // Remove param if value is empty
                    params = urlQueryString.replace(removeRegex, "$1");
                    params = params.replace(/[&;]$/, "");
                } else if (urlQueryString.match(updateRegex) !== null) {
                    // If param exists already, update it
                    params = urlQueryString.replace(
                        updateRegex,
                        "$1" + newParam
                    );
                } else {
                    // Otherwise, add it to end of query string
                    params =
                        urlQueryString == ""
                            ? "?" + newParam
                            : urlQueryString + "&" + newParam;
                }
            }

            // no parameter was set so we don't need the question mark
            params = params === "?" ? "" : params;

            return baseUrl + params;
        },

        updateQueryStringParameter: function (uri, key, value) {
            // remove the hash part before operating on the uri
            var i = uri.indexOf("#");
            var hash = i === -1 ? "" : uri.substr(i);
            uri = i === -1 ? uri : uri.substr(0, i);

            var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
            var separator = uri.indexOf("?") !== -1 ? "&" : "?";

            if (!value) {
                // remove key-value pair if value is empty
                uri = uri.replace(
                    new RegExp("([?&]?)" + key + "=[^&]*", "i"),
                    ""
                );
                if (uri.slice(-1) === "?") {
                    uri = uri.slice(0, -1);
                }
                // replace first occurrence of & by ? if no ? is present
                if (uri.indexOf("?") === -1) uri = uri.replace(/&/, "?");
            } else if (uri.match(re)) {
                uri = uri.replace(re, "$1" + key + "=" + value + "$2");
            } else {
                uri = uri + separator + key + "=" + value;
            }
            return uri + hash;
        },

        removeURLParameter: function (key) {
            window.history.replaceState(
                "",
                "",
                api.fn.removeURLParameter_fn(key)
            );
        },

        removeURLParameter_fn: function (parameter) {
            var url = window.location.href;
            //prefer to use l.search if you have a location/link object
            var urlparts = url.split("?");
            if (urlparts.length >= 2) {
                var prefix = encodeURIComponent(parameter) + "=";
                var pars = urlparts[1].split(/[&;]/g);

                //reverse iteration as may be destructive
                for (var i = pars.length; i-- > 0; ) {
                    //idiom for string.startsWith
                    if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                        pars.splice(i, 1);
                    }
                }

                return (
                    urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "")
                );
            }
            return url;
        },

        uniqueValues: function (theArray) {
            function contains(newArrr, v) {
                for (var i = 0; i < newArrr.length; i++) {
                    if (newArrr[i] === v) return true;
                }
                return false;
            }

            var arr = [];
            for (var i = 0; i < theArray.length; i++) {
                if (!contains(arr, theArray[i])) {
                    arr.push(theArray[i]);
                }
            }
            return arr.concat([]);
        },

        zoomLevel: function () {
            api.vars.zoomLevel = Math.round(window.devicePixelRatio * 100);

            if (api.vars.zoomLevel < 100) {
                $("html").addClass("zoomout");
            } else {
                $("html").removeClass("zoomout");
            }
        },

        iniShareLinks: function () {
            var shareUrl = window.location.href;

            jQuery("body").on("click", ".sharemenu .slnk_fb", function (e) {
                e.preventDefault();

                var lnk = jQuery(this);
                if (typeof lnk.data("shareurl") == "string")
                    shareUrl = lnk.data("shareurl");
                shareUrl = shareUrl
                    .replace(/(ifr=)[^\&]+/, "")
                    .replace("?&", "?");

                window.open(
                    "https://www.facebook.com/sharer/sharer.php?u=" +
                        encodeURIComponent(shareUrl),
                    "Facebook",
                    "width=626,height=436"
                );
            });

            jQuery("body").on("click", ".sharemenu .slnk_twit", function (e) {
                e.preventDefault();

                var lnk = jQuery(this);
                if (typeof lnk.data("shareurl") == "string")
                    shareUrl = lnk.data("shareurl");
                shareUrl = shareUrl
                    .replace(/(ifr=)[^\&]+/, "")
                    .replace("?&", "?");
                window.open(
                    "http://twitter.com/home?status=" +
                        encodeURIComponent(shareUrl),
                    "twitter-share-dialog",
                    "width=650,height=450"
                );
            });

            jQuery("body").on("click", ".sharemenu .slnk_lin", function (e) {
                e.preventDefault();

                var lnk = jQuery(this);
                if (typeof lnk.data("shareurl") == "string")
                    shareUrl = lnk.data("shareurl");
                shareUrl = shareUrl
                    .replace(/(ifr=)[^\&]+/, "")
                    .replace("?&", "?");
                window.open(
                    "https://www.linkedin.com/cws/share?url=" +
                        encodeURIComponent(shareUrl),
                    "linkedin-share-dialog",
                    "width=650,height=450"
                );
            });

            jQuery("body").on("click", "a.slnk_print", function (e) {
                e.preventDefault();

                print();
            });
        },

        suffle: function (o) {
            for (
                var j, x, i = o.length;
                i;
                j = parseInt(Math.random() * i),
                    x = o[--i],
                    o[i] = o[j],
                    o[j] = x
            );
            return o;
        },

        sanitizeString(str) {
            //https://stackoverflow.com/questions/23187013/is-there-a-better-way-to-sanitize-input-with-javascript
            str = str.replace(/[^a-z0-9áéíóúñü \.,_-]/gim, "");
            return str.trim();
        },

        groupedArray(items, n) {
            return new Array(Math.ceil(items.length / n))
                .fill()
                .map((_) => items.splice(0, n));
        },

        hexToRgb(hex) {
            // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
            var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
            hex = hex.replace(shorthandRegex, function (m, r, g, b) {
                return r + r + g + g + b + b;
            });

            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result
                ? {
                      r: parseInt(result[1], 16),
                      g: parseInt(result[2], 16),
                      b: parseInt(result[3], 16),
                  }
                : null;
        },

        validEmail(email) {
            var re =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },

        acceptNumber(phone) {
            var x = phone
                .replace(/\D/g, "")
                .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            return !x[2]
                ? x[1]
                : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
        },
        toFix (value) {
            return value.toFixed(2)
        },
        addCommasFilter (nStr, septhou, sepdec) {
            nStr += '';
            x = nStr.split('.');
            x1 = x[0];
            x2 = x.length > 1 ? sepdec + x[1] : '';
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + septhou + '$2');
            }
            return x1 + x2;
        },
        getNumberFromCustomDec: function (val) {
        	if(!isNaN(val))
                return val

        	var comma = val.indexOf(',');

        	if (comma) {
        		var intPart = val.split(',')[0];
        		var decPart = val.split(',')[1];
        	}
        	var outp = "";
        	outp += intPart;
        	if (comma > 0) outp += "." + decPart;
        	return outp;
        },
        removeDotsOrCommas: function(str, comma){
            var hasComma = str.indexOf(comma);
            return str.replace(/[.,]+/g, "");
        },

        equalMinHeights: function (elements, minHeight) {
            tallest = minHeight ? minHeight : 0;
            elements.each(function () {
                if ($(this).outerHeight() > tallest) {
                    tallest = $(this).outerHeight();
                }
            });

            return elements.each(function () {
                $(this).css("min-height", tallest);
            });
        },

        redirectToJobPage: function () {
            $(".s-hr__select .form-select").on("change", function () {
                var url = $(this).val();
                if (url) {
                    // require a URL
                    window.location = url; // redirect
                }
                return false;
            });
        },

        updateFavicon: function () {
            matcher = window.matchMedia("(prefers-color-scheme: dark)");
            lightSchemeIcon = document.querySelector("link#light-scheme-icon");
            darkSchemeIcon = document.querySelector("link#dark-scheme-icon");

            if (matcher.matches) {
                lightSchemeIcon.remove();
                document.head.append(darkSchemeIcon);
            } else {
                document.head.append(lightSchemeIcon);
                darkSchemeIcon.remove();
            }
        },

        clone(obj) {
            // from just-clone  https://github.com/angus-c/just#just-clone

            function getRegExpFlags(regExp) {
                if (typeof regExp.source.flags == "string") {
                    return regExp.source.flags;
                } else {
                    var flags = [];
                    regExp.global && flags.push("g");
                    regExp.ignoreCase && flags.push("i");
                    regExp.multiline && flags.push("m");
                    regExp.sticky && flags.push("y");
                    regExp.unicode && flags.push("u");
                    return flags.join("");
                }
            }
            if (typeof obj == "function") {
                return obj;
            }
            var result = Array.isArray(obj) ? [] : {};
            for (var key in obj) {
                // include prototype properties
                var value = obj[key];
                var type = {}.toString.call(value).slice(8, -1);
                if (type == "Array" || type == "Object") {
                    result[key] = api.fn.clone(value);
                } else if (type == "Date") {
                    result[key] = new Date(value.getTime());
                } else if (type == "RegExp") {
                    result[key] = RegExp(value.source, getRegExpFlags(value));
                } else {
                    result[key] = value;
                }
            }
            return result;
        },

        passiveListeners() {

            jQuery.event.special.touchstart = {
                setup: function( _, ns, handle ) {
                    this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
                }
            };
            jQuery.event.special.touchmove = {
                setup: function( _, ns, handle ) {
                    this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
                }
            };
            jQuery.event.special.wheel = {
                setup: function( _, ns, handle ){
                    this.addEventListener("wheel", handle, { passive: true });
                }
            };
            jQuery.event.special.mousewheel = {
                setup: function( _, ns, handle ){
                    this.addEventListener("mousewheel", handle, { passive: true });
                }
            };

        },

        downloadFile (url) {
            var a = document.createElement('A');
            a.href = url;
            a.download = url.substr(url.lastIndexOf('/') + 1);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },

        guid(){
            return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        },

        getSvgSource(){
            var svgs = $('[data-svg-src]:not(.loaded)');

            svgs.each((index, svg) => {
                var svg = $(svg)
                var url = svg.data('svg-src');
                if (svg.html().trim() === "" && url) {
                    try {
                        axios
                            .get(url)
                            .then((resp)=>{
                                if(resp.status===200){
                                    svg.addClass('loaded').html(resp.data);                                    
                                }
                            })
                            .catch((errors) => {
                                // ignore
                            })
                            .then(() => {
                            })
                    } catch (err) {
                        //console.warn(err.message)
                    }
                }
            })
        },
        
        equalHeights: function (elements, allowOverflow, minHeight, maxHeight) {
        	var tallest = (minHeight) ? minHeight : 0;

        	elements.each(function () {
        		if (jQuery(this).height() > tallest) {
        			tallest = jQuery(this).height();
        		}
        	});

        	if ((maxHeight) && tallest > maxHeight) tallest = maxHeight;

        	return elements.each(function () {
        		if (allowOverflow) {
        			jQuery(this).height(tallest);
        		} else {
        			jQuery(this).height(tallest).css("overflow", "hidden");
        		}
        	});
        },

        // deepMerge: function (target, source) {
        //     console.log('target', target);
        //     console.log('source', source);
            
        //     if (typeof target !== 'object' || target === null) return source;
        //     if (typeof source !== 'object' || source === null) return target;

        //     const merged = Array.isArray(target) ? [...target] : { ...target };

        //     for (const key in source) {
        //         if (source.hasOwnProperty(key)) {
        //             if (
        //                 typeof source[key] === 'object' &&
        //                 source[key] !== null &&
        //                 typeof target[key] === 'object' &&
        //                 target[key] !== null
        //             ) {
        //                 merged[key] = api.fn.deepMerge(target[key], source[key]); // Recursively merge
        //             } else {
        //                 merged[key] = source[key]; // Overwrite with source
        //             }
        //         }
        //     }

        //     return merged;
        // }

        deepMerge: function (target, source) {            
            if (typeof target !== 'object' || target === null) return source;
            if (typeof source !== 'object' || source === null) return target;
            
            // Create a copy of the target
            const merged = Array.isArray(target) ? [...target] : { ...target };
            
            for (const key in source) {
                if (source.hasOwnProperty(key)) {
                    if (
                        typeof source[key] === 'object' &&
                        source[key] !== null &&
                        typeof target[key] === 'object' &&
                        target[key] !== null
                    ) {
                        // Special handling for arrays
                        if (Array.isArray(source[key]) && Array.isArray(target[key])) {
                            // Check if array contains primitive values or objects with identifiable field
                            if (source[key].length > 0 && 
                                (typeof source[key][0] !== 'object' || source[key][0] === null)) {
                                // For arrays of primitive values, create a Set to deduplicate
                                merged[key] = [...new Set([...target[key], ...source[key]])];
                            } else {
                                // For arrays of objects, check if they have a common identifiable property
                                const firstSourceObj = source[key].find(item => typeof item === 'object' && item !== null);
                                const firstTargetObj = target[key].find(item => typeof item === 'object' && item !== null);
                                
                                // Determine if objects have a common identifier field (like "field", "id", etc.)
                                const identifierField = firstSourceObj && firstTargetObj ? 
                                    Object.keys(firstSourceObj).find(prop => 
                                        firstTargetObj.hasOwnProperty(prop) && 
                                        typeof firstSourceObj[prop] !== 'object' &&
                                        typeof firstTargetObj[prop] !== 'object'
                                    ) : null;
                                
                                if (identifierField) {
                                    // Merge objects in arrays using the identifier field
                                    merged[key] = [...target[key]];
                                    source[key].forEach(sourceItem => {
                                        if (typeof sourceItem === 'object' && sourceItem !== null && 
                                            sourceItem.hasOwnProperty(identifierField)) {
                                            const existingIndex = merged[key].findIndex(item => 
                                                typeof item === 'object' && item !== null &&
                                                item.hasOwnProperty(identifierField) &&
                                                item[identifierField] === sourceItem[identifierField]
                                            );
                                            if (existingIndex >= 0) {
                                                merged[key][existingIndex] = api.fn.deepMerge(merged[key][existingIndex], sourceItem);
                                            } else {
                                                merged[key].push(sourceItem);
                                            }
                                        } else {
                                            // For objects without the identifier field, just add
                                            merged[key].push(sourceItem);
                                        }
                                    });
                                } else {
                                    // If no common identifier, concat the arrays
                                    merged[key] = [...target[key], ...source[key]];
                                }
                            }
                        } else {
                            // Normal recursive merge for non-array objects
                            merged[key] = api.fn.deepMerge(target[key], source[key]);
                        }
                    } else {
                        // Simple assignment for non-objects
                        merged[key] = source[key];
                    }
                }
            }
            return merged;
        }

    };
})(jQuery);
